import { render, staticRenderFns } from "./Interview.vue?vue&type=template&id=4edc88ba&scoped=true"
import script from "./Interview.vue?vue&type=script&lang=js"
export * from "./Interview.vue?vue&type=script&lang=js"
import style0 from "./Interview.vue?vue&type=style&index=0&id=4edc88ba&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edc88ba",
  null
  
)

export default component.exports